import { jsxs as b, jsx as r } from "react/jsx-runtime";
import F, { forwardRef as le, useState as y, useRef as E } from "react";
import { s as a, C as oe } from "../../ChoicesItem-CGIr6Qga.mjs";
import { publish as X } from "../../utils/events.js";
import { classes as f } from "../../utils/helpers.js";
import { s as v, C as ie, A as ne } from "../../Form.module-DbpB9u1l.mjs";
import { X as ae } from "../../x-D8_C2o-U.mjs";
import { T as ue } from "../../triangle-D0AHL9lB.mjs";
import { P as j } from "../../index-CZzwT3Oj.mjs";
function I() {
  return I = Object.assign || function(t) {
    for (var u = 1; u < arguments.length; u++) {
      var l = arguments[u];
      for (var o in l)
        Object.prototype.hasOwnProperty.call(l, o) && (t[o] = l[o]);
    }
    return t;
  }, I.apply(this, arguments);
}
function de(t, u) {
  if (t == null) return {};
  var l = he(t, u), o, c;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (c = 0; c < i.length; c++)
      o = i[c], !(u.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t, o) && (l[o] = t[o]);
  }
  return l;
}
function he(t, u) {
  if (t == null) return {};
  var l = {}, o = Object.keys(t), c, i;
  for (i = 0; i < o.length; i++)
    c = o[i], !(u.indexOf(c) >= 0) && (l[c] = t[c]);
  return l;
}
var R = le(function(t, u) {
  var l = t.color, o = l === void 0 ? "currentColor" : l, c = t.size, i = c === void 0 ? 24 : c, P = de(t, ["color", "size"]);
  return /* @__PURE__ */ F.createElement("svg", I({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, P), /* @__PURE__ */ F.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }));
});
R.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
R.displayName = "ChevronDown";
function Ce({
  name: t,
  options: u,
  label: l = "",
  width: o = 100,
  multiple: c = !1,
  placeholder: i = "",
  ValidIcon: P = ie,
  InvalidIcon: G = ne,
  expandIconType: L = "default",
  // default, chevron
  showValidation: x = !0,
  ...J
}) {
  var H, U, B;
  const [Q, Y] = y(`${v["form-field__input"]}`), w = E(), T = E(), [V, q] = y(""), [D, Z] = y("clean"), [k, K] = y([]), [m, $] = y(u.map((e, d) => ({
    ...e,
    id: e != null && e.id ? e == null ? void 0 : e.id : `${t}-${d + 1}`,
    status: "active"
  }))), [A, ee] = y(null), [p, M] = y("hidden"), n = E(-1), te = `input-width--${o}`, z = (e, d, h = "selected") => {
    if (!c && h === "selected" || h === "highlighted") {
      for (const s of e)
        if (s.status === h) {
          s.status = "active";
          break;
        }
    }
    for (const s of e)
      if (s.id === d && (c && s.status !== "selected" && h === "selected" && K([...k, s]), s.status !== "selected" && (s.status = h), h === "selected")) {
        ee(s);
        break;
      }
    return e;
  }, se = () => {
    setTimeout(() => {
      w.current.checkValidity() ? q("") : q(w.current.validationMessage);
    }, 100);
  }, C = (e) => {
    e == null || e.stopPropagation(), Z("touched"), Y(`${v["form-field__input"]} ${v["input--touched"]}`), p === "hidden" ? M("visible") : (M("hidden"), se());
  }, ce = (e) => {
    const h = k.filter((g) => g.id !== e);
    K([...h]);
    let s = m;
    const _ = (g, N) => {
      for (const O of g) {
        if (O.id === N) {
          O.status = "active";
          break;
        }
        O.subcategories.length && _(O.subcategories, N);
      }
      return g;
    }, S = _(s, e);
    $([...S]), document.querySelector(`select[name="${t}"] > option[value="${e}"]`).selected = !1;
  }, re = (e) => {
    const d = structuredClone(m), h = z(d, e);
    $([...h]), C(), n.current = -1;
    const s = m.find((_) => _.id === e);
    document.querySelector(`select[name="${t}"] > option[value="${s.value}"]`).selected = !0, X("scripps:customselect:selected", { value: s.value });
  }, W = (e) => {
    if (e.key === "Tab" || (e.key === "ArrowDown" || e.key === "ArrowUp") && p !== "visible") return !0;
    e.stopPropagation(), e.preventDefault();
    const d = e.key, h = m, s = (_) => {
      const S = z(h, m[_].id, "highlighted");
      $([...S]);
    };
    if (d === "ArrowDown" && p === "visible")
      n.current < m.length - 1 ? (s(n.current + 1), n.current++) : (s(0), n.current = 0);
    else if (d === "ArrowUp" && p === "visible")
      n.current > 0 ? (s(n.current - 1), n.current--) : (s(m.length - 1), n.current = m.length - 1);
    else if (d === "Enter")
      if (p === "visible" && n.current !== -1) {
        const _ = m[n.current].id, S = z(h, _);
        $([...S]), C(), n.current = -1;
        const g = m.find((N) => N.id === _);
        document.querySelector(`select[name="${t}"] > option[value="${g.value}"]`).selected = !0, X("scripps:customselect:selected", { value: g.value });
      } else
        C();
    else if (d === "Escape" && p === "visible")
      C(), n.current = -1;
    else
      return !1;
    30 * n.current > 160 ? T.current.scrollTo(0, 30 * n.current) : T.current.scrollTo(0, 0);
  };
  return /* @__PURE__ */ b("label", { htmlFor: t, className: f([
    v["form-field"],
    v[te]
  ]), children: [
    x && /* @__PURE__ */ b(
      "i",
      {
        className: [
          v["form-field__icon"],
          (H = w.current) != null && H.validity.valid ? "" : v["form-field__icon--invalid"]
        ].join(" "),
        style: l === "" ? { top: "0.4em" } : {},
        children: [
          ((U = w.current) == null ? void 0 : U.checkValidity()) && D === "touched" && /* @__PURE__ */ r(P, {}),
          !((B = w.current) != null && B.checkValidity()) && D === "touched" && /* @__PURE__ */ r(G, {})
        ]
      }
    ),
    l !== "" && /* @__PURE__ */ r("span", { className: v["form-field__label"], children: l }),
    /* @__PURE__ */ b(
      "select",
      {
        name: t,
        className: f([
          a["custom-select__select"],
          D === "touched" && x ? a["custom-select__select--touched"] : ""
        ]),
        multiple: c,
        ref: w,
        tabIndex: "-1",
        ...J,
        children: [
          /* @__PURE__ */ r("option", { value: "" }),
          u.length && u.map((e) => /* @__PURE__ */ r("option", { value: e.value, selected: e.selected, children: e.label }, `option-${e.value}`))
        ]
      }
    ),
    /* @__PURE__ */ b("div", { className: f([Q, a["custom-select"], "custom-select"]), onKeyDown: W, tabIndex: "0", children: [
      c && /* @__PURE__ */ b("ul", { className: f([a["custom-select__selections"], "custom-select__selections"]), onClick: C, children: [
        k.length !== 0 && k.map((e) => /* @__PURE__ */ b("li", { className: f([a["custom-select__selected"], "custom-select__selected"]), children: [
          e.label,
          /* @__PURE__ */ r(
            "button",
            {
              title: "remove",
              type: "button",
              className: a["custom-select__remove"],
              onClick: (d) => {
                d.stopPropagation(), ce(e.id);
              },
              children: /* @__PURE__ */ r(ae, { width: 16, height: 16 })
            }
          )
        ] })),
        k.length === 0 && i !== "" && /* @__PURE__ */ r("span", { className: f([a["custom-select__placeholder"], "custom-select__placeholder"]), children: i })
      ] }),
      !c && /* @__PURE__ */ b("div", { className: `${a["custom-select__selection"]}`, onClick: C, children: [
        A && A.label,
        !A && i !== "" && /* @__PURE__ */ r("span", { className: f([a["custom-select__placeholder"], "custom-select__placeholder"]), children: i })
      ] }),
      /* @__PURE__ */ r("div", { className: f([
        a["custom-select__choices-wrapper"],
        "custom-select__choices-wrapper",
        p === "visible" ? "" : a["custom-select__choices-wrapper--hidden"]
      ]), children: /* @__PURE__ */ r("div", { className: f([a["custom-select__choices"], "custom-select__choices"]), ref: T, onKeyDown: W, children: /* @__PURE__ */ r("ul", { children: m.length !== 0 && m.map((e) => /* @__PURE__ */ r(oe, { item: e, handleOnClick: re }, `choice-${e.id}`)) }) }) }),
      L === "default" && /* @__PURE__ */ r("i", { className: a["custom-select__icon"], children: /* @__PURE__ */ r(ue, {}) }),
      L === "chevron" && /* @__PURE__ */ r("i", { className: f([a["custom-select__icon"], a["custom-select__icon--chevron"], "custom-select__icon--chevron"]), children: /* @__PURE__ */ r(R, {}) })
    ] }),
    V !== "" && x && /* @__PURE__ */ r("div", { className: f([v["form-field__error-message"], "form-field__error-message"]), children: V })
  ] });
}
export {
  Ce as CustomSelect,
  Ce as default
};
